/**
 * Thin logger shim — dev-visible, production-silent.
 *
 * The previous code-quality pass required us to replace silent catch blocks
 * with `console.warn`/`console.error` for ops visibility. The follow-up pass
 * flagged those console statements as "leaking internal logic in production".
 * Both reviews are right in context — the resolution is to keep the logging
 * call sites AS-IS in source but gate the actual stdout write behind a
 * NODE_ENV check so production builds emit nothing and dev/CI still see the
 * signal. This also gives us one place to later swap in a real service
 * (Sentry, LogRocket, Datadog) without touching every call site.
 */

const IS_PROD = process.env.NODE_ENV === "production";

function noop() {}

export const logger = {
  // Transient / expected-to-sometimes-fail noise (polling, optional UI,
  // localStorage-in-private-mode, etc.) Never emitted in prod.
  debug: IS_PROD ? noop : (...args) => console.warn(...args),
  // Unexpected failures — emitted in prod too so Sentry/console can still
  // pick them up. Safe to swap for a dedicated error-reporting client later.
  error: IS_PROD ? (...args) => console.error(...args) : (...args) => console.error(...args),
};
